import React, { useEffect, useState } from 'react'
import { DataSelectType } from '../models/DataSelectType';
import { useDarkModeStore } from '../store/useDarkModeStore';
import { useLanguageStore } from '../store/useLanguageStore';
import { darkModeBackgroudInputs } from '../utils/constants';

interface DinamicInputFilterProps {
    field: string;
    type?: string;
    resetTrigger: number;
    fieldDisplayName: string;
    filterData: DataSelectType[] | undefined;
    setFilterData: React.Dispatch<React.SetStateAction<DataSelectType[] | undefined>>;
}

export const DinamicInputFilter: React.FC<DinamicInputFilterProps> = ({
    filterData, field, fieldDisplayName, type = 'text', resetTrigger, setFilterData
}) => {
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const [searchTerm, setSearchTerm] = useState<string>('');

    useEffect(() => {
        setSearchTerm('');
    }, [resetTrigger]);

    useEffect(() => {
        if (filterData) {
            let existData = filterData.find(item => item.isInput && item.field === field);
            if (existData) setSearchTerm(existData.value);
        }
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let upFilterData = filterData ? filterData : [];
        const { value } = e.target;
        setSearchTerm(value);
        if (value !== '') {
            let existingIndex = upFilterData.findIndex(item => item.field === field);
            if (existingIndex !== -1) upFilterData[existingIndex].value = value;
            else upFilterData.push({ label: '', value, isInput: true, field });

            setFilterData(upFilterData)
        } else {
            let result = upFilterData.filter(item => item.field !== field);
            setFilterData(result)
        }
    }

    return (
        <div className='d-flex flex-column gap-1'>
            <label
                htmlFor={field}
                className={`fw-bold ${darkMode ? 'text-white' : 'text-muted'}`}
                style={{ fontSize: 12 }}
            >
                {language[fieldDisplayName]}
            </label>
            <input
                id={field}
                type={type}
                value={searchTerm}
                onChange={handleChange}
                className='form form-control'
                style={darkMode ? { color: 'white', background: darkModeBackgroudInputs } : {}}
            />
        </div>
    );
}
export default DinamicInputFilter;